<template>
  <div class="graphic-info-container">
    <el-card>
      <template #header>
        <TitleItem title="图文信息" />
      </template>
      <el-form ref="graphicInfoForm" :model="graphicInfoModel" label-width="125px">
        <el-form-item label="卖点描述">
          <el-row>
            <el-col :span="12">
              <el-input v-model="graphicInfoModel.description" maxlength="30" placeholder="请输入商品卖点描述(至多30字)"></el-input>
              <p class="desc-tips">用于描述商品售卖亮点、商品优势，商品详情页面标题下方展示</p>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="商品属性">
          <el-row>
            <el-col :span="12">
              <el-input type="textarea" :rows="2" v-model="graphicInfoModel.desc" maxlength="100" placeholder="请输入商品属性(至多100字)"></el-input>
              <p class="desc-tips">商品属性用来描述商品详细介绍，商品详情页面中展示</p>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item v-if="prescriptionSet" label="是否处方药" required>
          <el-radio-group v-model="graphicInfoModel.isPrescription">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="商品图片" :rules="[
          { required: shopConfig && shopConfig.shopDtlEntity && shopConfig.shopDtlEntity.shopSort!='ORDER_GOODS', message: ''},
        ]">
          <ImageUpload ref="goodsPicRef" :sizeLimit="1" />
          <p class="desc-tips">
            仅支持jpg、jpeg、png文件格式,文件大小建议1M以内,建议尺寸:460像素x460素,至少上传1张图,至多上传10张图,商品图片可展在商品详情页面或视频缩略图
          </p>
        </el-form-item>
        <el-form-item label="商品大图">
          <ImageUpload ref="goodsBigPicRef" :limit="1" :sizeLimit="1.5" />
          <p class="desc-tips">
            仅支持jpg、jpeg、png文件格式,文件大小建议1.5M以内,建议尺寸350像素x135像素,仅支持上传1张图商品大图可展示在商品列表中或视频缩略图
          </p>
        </el-form-item>
        <el-form-item label="商品视频">
          <VideoUpload ref="goodsVideoRef" />
          <p class="desc-tips">仅支持mp4、webm、ogv格式视频文件,建议视频时间在30s以内,大小不超过50m,至多上传1个视频商品视频可展示在商品详情或商品列表中</p>
        </el-form-item>
        <el-form-item label="讲解视频">
          <VideoUpload ref="goodsVideoRef2" />
          <p class="desc-tips">仅支持mp4、webm、ogv格式视频文件,建议视频时间在30s以内,大小不超过50m,至多上传1个讲解视频可展示在商品详情</p>
        </el-form-item>
        <el-form-item label="商品详情" :rules="[
          { required: shopConfig && shopConfig.shopDtlEntity && shopConfig.shopDtlEntity.shopSort!='ORDER_GOODS', message: ''},
        ]">
          <Tinymce ref="tinymce" id="goodsDetail" />
        </el-form-item>
        <el-form-item label="其他说明">
          <el-row>
            <el-col :span="12">
              <el-input v-model="graphicInfoModel.using" maxlength="30" show-word-limit></el-input>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import Tinymce from "@/components/tinymce";
import { encode } from "js-base64";
import TitleItem from "./TitleItem.vue";
import ImageUpload from "./ImageUpload.vue";
import VideoUpload from "./VideoUpload.vue";

const { mapState } = createNamespacedHelpers("publishGoods/publishGoods");
export default {
  components: {
    TitleItem,
    ImageUpload,
    VideoUpload,
    Tinymce,
  },
  data() {
    return {
      shopSort:"",
      prescriptionSet: false, //= true时，展示 是否处方药配置
      graphicInfoModel: {
        description: "", //卖点描述
        desc: "", //"货品属性"
        isPrescription: 0, // 是否处方药 0:否，1:是
        using: "", //其他说明
      },
    };
  },
  computed: {
    ...mapState(["goodsDetail", "shopConfig"]),
  },
  watch: {
    goodsDetail(newVal) {
      this.graphicInfoModel.description = newVal.firstSku.description;
      this.graphicInfoModel.desc = newVal.firstSku.desc;
      this.graphicInfoModel.isPrescription = newVal.firstSku.isPrescription;
      this.graphicInfoModel.using = newVal.firstSku.using;
      //货品图片(10张图)
      this.$refs.goodsPicRef.fileList = newVal.firstSku.picList.map((item) => ({ url: `${item.url}?imageView2/1/w/200/h/200` }));
      // 一张大图
      if (newVal && newVal.firstSku && newVal.firstSku.picUrlCover) {
        this.$refs.goodsBigPicRef.fileList = [{ url: `${newVal.firstSku.picUrlCover}` }];
      } else {
        this.$refs.goodsBigPicRef.fileList = [];
      }

      // this.$refs.goodsBigPicRef.fileList = [{ url: `${newVal.firstSku.picUrlCover}?imageView2/1/w/200/h/200` }];
      // 视频
      this.$refs.goodsVideoRef.videoUrl = newVal.firstSku.videoUrl;
      // 讲解视频
      this.$refs.goodsVideoRef2.videoUrl = newVal.firstSku.explanationVideoUrl;

      setTimeout(() => {
        this.$refs.tinymce.setMain(newVal.firstSku.attrUrl);
      }, 300);
    },
    shopConfig(newVal) {
      this.prescriptionSet = newVal.prescriptionSet;
    },
  },
  methods: {
    async subMitCheck() {
      this.shopSort=this.shopConfig && this.shopConfig.shopDtlEntity && this.shopConfig.shopDtlEntity.shopSort || "";
      if(this.shopSort!="ORDER_GOODS"){
        if (!this.$refs.goodsPicRef.fileList.length) {
          this.$message.error("请上传商品图片");
          return;
        }
        if (!this.$refs.tinymce.getMain()) {
          this.$message.error("请填写商品详情");
          return;
        }
      }
      const graphicInfo = { ...this.graphicInfoModel };
      // 10张图
      graphicInfo.picUrlList = this.$refs.goodsPicRef.fileList.map((item) => item.url.replace("?imageView2/1/w/200/h/200", ""));
      // 一张大图
      if (this.$refs.goodsBigPicRef.fileList.length > 0) {
        graphicInfo.picUrlCover = this.$refs.goodsBigPicRef.fileList[0].url.replace("?imageView2/1/w/200/h/200", "");
      }

      // 视频
      if (this.$refs.goodsVideoRef.videoUrl) {
        graphicInfo.videoUrl = this.$refs.goodsVideoRef.videoUrl;
      } else {
        graphicInfo.videoUrl = "";
      }

      // 讲解视频
      if (this.$refs.goodsVideoRef2.videoUrl) {
        graphicInfo.explanationVideoUrl = this.$refs.goodsVideoRef2.videoUrl;
      } else {
        graphicInfo.explanationVideoUrl = "";
      }

      console.log(this.$refs.tinymce.getMain());
      graphicInfo.attrUrl = encode(this.$refs.tinymce.getMain());

      return graphicInfo;
    },
  },
};
</script>

<style lang="scss" scoped>
.graphic-info-container {
  padding-top: 20px;
  .desc-tips {
    font-size: 12px;
    color: grey;
    line-height: 1.6;
  }
}
</style>
